import * as yup from 'yup';

export const promoCodeSchema = yup.object({
  name: yup.string().max(150, 'Code Label must be at most 150 characters').required('Code Label is required').trim(),
  code: yup
    .string()
    .typeError('Promo Code must be a number')
    .required('Promo Code is required')
    .min(0, 'Promo Code must be at least 0'),
  maxUses: yup
    .number()
    .typeError('Usage Limits must be a number')
    .required('Usage Limits is required')
    .min(1, 'Usage Limits must be at least 1'),
  type: yup.string().nullable(),
  isActive: yup.boolean().required('Active status is required'),
  expirationDate: yup
    .date()
    .typeError('Expiration Date must be a valid date')
    .required('Expiration Date is required')
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Expiration Date cannot be in the past'),
  // associatedPartner: yup
  //   .string()
  //   .nullable(),
});
